import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/houzz': {
    width: 414,
    height: 512,
    paths: [
      {
        d: 'M258.9 330.7H154.3V480H0V32H109.5V136.5L414.6 222.1V480H258.9V330.7z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/houzz.js
// module id = wHOA
// module chunks = 144